import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { NewsfeedResultsFacade } from '../state/newsfeed-results/newsfeed-results.facade';
import { NewsfeedContentSource } from '../state/newsfeed-results/newsfeed-results.models';

@Injectable()
export class SubscriptionNewsfeedResolver {
  constructor(private facade: NewsfeedResultsFacade) {}
  resolve(route: ActivatedRouteSnapshot): boolean {
    let source: NewsfeedContentSource = { feed: 'ROOT' };

    const channel = route.paramMap.get('exhibitor_id');
    const fair = route.paramMap.get('fair_id');
    if (channel && fair) {
      source = { feed: 'SUBSCRIPTION', fair, channel };
    }

    this.facade.setSource(source);
    return true;
  }
}
